export default __webpack_public_path__ + "static/media/Predictive-Maintenance.d89e0980.jpg";